(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collection-carousel]').forEach(carousel => {
    const tabs = carousel.querySelectorAll('[data-carousel-tab]');
    const panels = carousel.querySelectorAll('[data-carousel-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.carouselTab;

        tabs.forEach(t => t.classList.remove('collection-carousel__tab--active'));
        tab.classList.add('collection-carousel__tab--active');

        panels.forEach(p => p.classList.add('collection-carousel__panel--hidden'));
        const activePanel = carousel.querySelector('[data-carousel-panel="' + index + '"]');
        if (activePanel) {
          activePanel.classList.remove('collection-carousel__panel--hidden');
          const track = activePanel.querySelector('.collection-carousel__track');
          if (track) track.scrollLeft = 0;
        }
      });
    });

    carousel.querySelectorAll('.collection-carousel__wrapper').forEach(wrapper => {
      const track = wrapper.querySelector('.collection-carousel__track');
      const prevBtn = wrapper.querySelector('.collection-carousel__arrow--prev');
      const nextBtn = wrapper.querySelector('.collection-carousel__arrow--next');

      if (!track) return;

      const scrollAmount = () => {
        const item = track.querySelector('.collection-carousel__item');
        return item ? item.offsetWidth + 24 : 300;
      };

      prevBtn?.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      nextBtn?.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.related-products__wrapper').forEach(wrapper => {
    const track = wrapper.querySelector('.related-products__track');
    const prevBtn = wrapper.querySelector('.related-products__arrow--prev');
    const nextBtn = wrapper.querySelector('.related-products__arrow--next');

    if (!track) return;

    const scrollAmount = () => {
      const item = track.querySelector('.related-products__item');
      return item ? item.offsetWidth + 24 : 300;
    };

    prevBtn?.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(container => {
    const url = container.dataset.url;
    if (!url) return;

    fetch(url)
      .then(res => res.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recs = html.querySelector('[data-product-recommendations]');
        if (recs && recs.innerHTML.trim()) {
          container.innerHTML = recs.innerHTML;
        }
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();
})();
